(() => {
  const SEARCH_URL = '/search';

  const injectDrawerSearch = () => {
    const container = document.querySelector('.menu-drawer__navigation-container');
    if (!container || document.querySelector('.vc-drawer-search')) return;

    const block = document.createElement('div');
    block.className = 'vc-drawer-search';
    block.innerHTML = `
      <form class="vc-drawer-search__form" action="${SEARCH_URL}" method="get" role="search">
        <label class="visually-hidden" for="VitaCoreDrawerSearch">Search VitaCore</label>
        <input id="VitaCoreDrawerSearch" class="vc-drawer-search__input" type="search" name="q" placeholder="Search VitaCore" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">
        <input type="hidden" name="options[prefix]" value="last">
        <button class="vc-drawer-search__button" type="submit">Search</button>
      </form>`;

    const nav = container.querySelector('.menu-drawer__navigation');
    container.insertBefore(block, nav || container.firstChild);
  };

  const run = () => injectDrawerSearch();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('click', () => window.requestAnimationFrame(injectDrawerSearch), true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.vc-drawer-search__form');
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    if (!input || input.value.trim()) return;
    event.preventDefault();
    input.focus();
  }, true);

  new MutationObserver(injectDrawerSearch).observe(document.documentElement, { childList: true, subtree: true });
})();
